"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toFirestore = exports.fromFirestore = exports.fromScheme = void 0;
const utils_1 = require("../utils");
function fromScheme(scheme, snapshot, defaults) {
    const data = { ...defaults };
    snapshot.forEach((doc) => {
        const key = doc.id;
        const value = doc.data().value;
        data[key] = fromFirestore(value, scheme[key]);
    });
    return data;
}
exports.fromScheme = fromScheme;
function fromFirestore(value, type) {
    switch (type) {
        case 'date':
            return value.toDate().toISOString();
        case 'string':
        case 'number':
        case 'array':
        case 'boolean':
        default:
            return value;
    }
}
exports.fromFirestore = fromFirestore;
function toFirestore(firestore, value, type) {
    switch (type) {
        case 'date':
            return firestore.Timestamp.fromDate(new Date(value));
        case 'array':
            return [...value];
        case 'number':
            return utils_1.toNumber(value);
        case 'boolean':
            return Boolean(value);
        case 'string':
        default:
            return value;
    }
}
exports.toFirestore = toFirestore;
//# sourceMappingURL=index.js.map